<script setup>
import {onMounted} from "vue";
import {useRoute, useRouter} from "vue-router";
import axios from "@/plugins/axios";
import toast from "@/plugins/bulmatoast";

const route = useRoute();
const router = useRouter();

onMounted(() => {
  if (route.query.confirmation_token) {
    axios.get(`/customer/cabinet/verify-email/${route.query.confirmation_token}`).then(() => {
      toast({
        message: "Профиль успешно зарегистрирован",
        type: "is-success",
      });
    }).catch((error) => {
      toast({
        message: error.response.data.detail,
        type: "is-danger",
      });
    })
  }
  router.push("/")
})
</script>

<template>
  <div>Подтверждение email</div>
</template>

<style scoped>

</style>